import {Divider} from "@mui/material";

// Divider component used to separate error messages in tooltips
export default () => <Divider style={{backgroundColor: "white", margin: "5px 0px", opacity: "0.5"}} />;
